import { api } from 'services/api';

import {
  INSERTION_ORDER_BULK_URL,
  INSERTION_ORDER_FULL_URL,
  LINE_ITEM_BULK_URL,
  UPDATE_STATUS_URL,
  REFRESH_METADATA_URL,
} from './constants';
import {
  DspInsertionOrder,
  DspInsertionOrderUpdate,
  DspLineItem,
  DspLineItemUpdate,
  DspStatusUpdate,
} from './dspApiTypes';

const getDspInsertionOrders = (advertiserId: string, dsp: string | null) => {
  return api.get<DspInsertionOrder[]>(
    `${dsp}/${INSERTION_ORDER_FULL_URL}?advertiserId=${advertiserId}`,
  );
};

const updateDspInsertionOrders = (
  updates: DspInsertionOrderUpdate[],
  dsp: string,
  currentAdvertiserId: string,
) => {
  return api.post<DspInsertionOrder[]>(
    `${dsp}/${INSERTION_ORDER_BULK_URL}?advertiserId=${currentAdvertiserId}`,
    updates,
  );
};

const updateDspLineItems = (
  updates: DspLineItemUpdate[],
  dsp: string,
  currentAdvertiserId: string,
) => {
  return api.post<DspLineItem[]>(
    `${dsp}/${LINE_ITEM_BULK_URL}?advertiserId=${currentAdvertiserId}`,
    updates,
  );
};

const updateStatus = (updates: DspStatusUpdate, dsp: string) => {
  const { id, enabled, advertiserId } = updates;

  return api.patch<DspInsertionOrder[]>(
    `${dsp}/${UPDATE_STATUS_URL}?id=${id}&enabled=${enabled}&advertiserId=${advertiserId}`,
  );
};

/**
 * Both DSPs expose /api/v1/{dsp}/refresh-metadata/{ENTITY}.
 *
 * The path segment is the enum KEY, not the value -- Adform's controller binds
 * the enum directly via Enum.valueOf, which only matches the constant name.
 * Every constant in both enums satisfies key === value.toUpperCase(), so the
 * key is derived rather than looked up.
 */
const refreshDspMetadata = (dsp: string, entityType: string) => {
  return api.post<string>(
    `${dsp.toLowerCase()}/${REFRESH_METADATA_URL}/${entityType.toUpperCase()}`,
  );
};

export const dspApi = {
  getDspInsertionOrders,
  updateDspInsertionOrders,
  updateDspLineItems,
  updateStatus,
  refreshDspMetadata,
};
